'use client'

import { LangCode } from '@/components/i18n/lang-context'
import { PRESS_ARTICLES } from '@/components/press/press-articles'
import { Partner } from '@/types/partner'
import { LBCarrousel } from './lb-carrousel'

export function LBPress({langCode, partner}: {langCode: LangCode, partner: Partner|undefined}) {

  return <LBCarrousel langCode={langCode} items={PRESS_ARTICLES} partner={partner}/>
}
